/**
 * Real API implementation for Onboarding.
 * GET /api/v3/onboarding/status – org from auth token; returns { success, data } or steps.
 */

import { apiClient } from '../apiClient';

const V3_ONBOARDING_STATUS = '/api/v3/onboarding/status';

/** Normalize: support { success, data } or raw payload. */
const normalize = (payload) => payload?.data ?? payload ?? null;

export const getOnboardingStatus = async () => {
  const response = await apiClient.get(V3_ONBOARDING_STATUS);
  const raw = response?.data ?? response;
  return normalize(raw) ?? raw;
};
